<template>

  <div>

    <div
      class="buymodal-block__body">

      <transition
        name="slide-left"
        mode="out-in">

        <div
          class="body-info"
          v-for="(item, i) in questions" :key="i"
          v-if="item.active">
          <div
            class="body-info__title">
            {{ item.name }} ({{ item.questions.findIndex(item => item.active == true) + 1 }} из {{ item.questions.length }})
          </div>

          <transition
            name="slide-left"
            mode="out-in">

            <div
            class="body-info__block"
            v-for="(quest, q) in item.questions" :key="q"
            v-if="quest.active">

            <div
              class="side">
              <div
                class="question-image">
                <img
                  @click="openImg(item.name, quest.image)"
                  :src="quest.image">
              </div>
            </div>
            <div
              class="side">
              <div
                class="question-block">
                <div
                  class="question-block__title">
                  {{ quest.question }}
                </div>
                <div
                  class="question-block__list">
                  <div
                    class="question-block__list-item">
                    <input
                      type="radio"
                      id="id1"
                      value="true"
                      ref="labelTrue"
                      name="checkLabel"
                      :checked="answers[answers.findIndex(item => item.id === quest.id)].answer == true ? 'checked' : false">
                    <label for="id1" class="label">
                      <span
                        class="label-btn"></span>
                      <span
                        class="label-text">
                        Да
                      </span>
                    </label>
                  </div>
                  <div
                    class="question-block__list-item">
                    <input
                      type="radio"
                      id="id2"
                      value="false"
                      ref="labelFalse"
                      name="checkLabel"
                      :checked="answers[answers.findIndex(item => item.id === quest.id)].answer == false ? 'checked' : false">
                    <label for="id2" class="label">
                      <span
                        class="label-btn"></span>
                      <span
                        class="label-text">
                        Нет
                      </span>
                    </label>
                  </div>
                  <div
                    v-if="error"
                    class="error-mess">
                    {{ error }}
                  </div>
                </div>
              </div>
            </div>

          </div>

          </transition>

        </div>

      </transition>

    </div>

    <div
      class="buymodal-block__footer">
      <button
        type="button"
        class="btn cancel"
        @click.prevent="$emit('leave')">
        Отказаться
      </button>
      <button
        type="button"
        class="btn cancel"
        :disabled="questions && questions[0].questions[0].active ? true : false"
        :class="questions && questions[0].questions[0].active ? 'disabled' : ''"
        @click.prevent="prev()">
        Назад
      </button>
      <button
        type="button"
        class="btn next"
        @click.prevent="next()">
        Продолжить
      </button>
    </div>

    <modal-image />

  </div>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import ModalImage from '@/components/Modals/ModalImage';
export default {
  components: {
    ModalImage,
  },
  data() {
    return {
      error: '',
    }
  },
  computed: {
    ...mapState('buymodels', ['model', 'questions', 'answers']),
  },
  mounted() {
    this.getQuestions();
  },
  methods: {
    ...mapActions('buymodels', ['getCalc', 'getQuestions']),
    ...mapMutations('buymodels', ['ADD_ANSWER']),
    ...mapMutations('layout', ['SET_MODAL_IMAGE']),
    openImg(title, image) {
      this.SET_MODAL_IMAGE({
        modal: true,
        bg: true,
        title,
        image,
      })
    },
    prev() {
      this.error = '';
      const questions = this.questions.slice();
      const firstItem = questions[0];
      const firstQuestion = firstItem.questions[0];
      if (firstItem.active == true && firstQuestion.active == true) {
        this.$emit('changeScreen', {type: 'prev', id: 1})
      } else {
        this.ADD_ANSWER({type: 'prev'});
      }
    },
    next() {
      this.error = '';
      const questions = this.questions.slice();
      const lastItem = questions[questions.length-1];
      const lastQuestion = lastItem.questions[lastItem.questions.length-1];
      const changeSc = lastItem.active != false && lastQuestion.active != false ? true : false;
      const refTrue = this.$refs.labelTrue[0].checked;
      const refFalse = this.$refs.labelFalse[0].checked;
      const answer = refTrue ? true : false;
      if (!refTrue && !refFalse) {
        this.error = 'Ответьте на вопрос!';
        return false;
      }
      let endQuestion = false; // последний ли это вопрос дял перехода на другую страницу
      if (answer == true) { // если ответ - да, то и все остальные ответы в данном блоке будут положительными
        let id = 0, leng = questions.length - 1;
        questions.map((item, i) => { // смотрим id активного блока вопросов
          if (item.active == true) {
            id = i;
            if (i == leng)
              endQuestion = true;
          }
        })
        let start = false, lengAfterActive = 0;
        questions[id].questions.map(item => {
          if (item.active)
            start = true;
          if (start)
            lengAfterActive++;
        })
        for (let key = 0; key < lengAfterActive; key++) // Стави всем вопоросам в данном блоке, ответ - да
          this.ADD_ANSWER({answer: true, type: 'next'});
      } else // если ответ нет, идём по порядку
        this.ADD_ANSWER({answer, type: 'next'});
      if (changeSc || endQuestion) // переход на новую страницу если вопросы закончились
        this.nextPage();
    },
    nextPage() {
      this.getCalc({
        btag: this.model.btag,
        questions: this.answers,
      })
      this.$emit('changeScreen', {type: 'next', id: 1})
    }
  },
}
</script>

<style lang="css">
</style>
